import { render, staticRenderFns } from "./setting-plan-management.vue?vue&type=template&id=db81a846"
import script from "./setting-plan-management.vue?vue&type=script&lang=js"
export * from "./setting-plan-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports